import React, { useEffect, useState } from 'react';

const FloatingRocket = () => {
  const [position, setPosition] = useState({ x: 20, y: 20 });
  const [direction, setDirection] = useState({ x: 1, y: 1 });

  useEffect(() => {
    const moveRocket = () => {
      setPosition(prev => {
        let newX = prev.x + direction.x * 0.5;
        let newY = prev.y + direction.y * 0.3;
        let newDirectionX = direction.x;
        let newDirectionY = direction.y;

        // Bounce off edges
        if (newX <= 0 || newX >= 95) {
          newDirectionX = -direction.x;
          newX = newX <= 0 ? 0 : 95;
        }
        if (newY <= 0 || newY >= 90) {
          newDirectionY = -direction.y;
          newY = newY <= 0 ? 0 : 90;
        }

        setDirection({ x: newDirectionX, y: newDirectionY });
        return { x: newX, y: newY };
      });
    };

    const interval = setInterval(moveRocket, 50);
    return () => clearInterval(interval);
  }, [direction]);

  // Calculate rotation based on direction - astronaut faces direction of movement
  const rotation = Math.atan2(direction.y, direction.x) * (180 / Math.PI);

  return (
    <div
      className="fixed pointer-events-none z-40 transition-all duration-100 ease-linear"
      style={{
        left: `${position.x}%`,
        top: `${position.y}%`,
      }}
    >
      <div className="relative" style={{ transform: `rotate(${rotation}deg)` }}>
        {/* Jetpack exhaust flames - positioned behind astronaut */}
        <div className="absolute -left-12 top-1/2 transform -translate-y-1/2 flex flex-col gap-1">
          <div className="w-16 h-2 bg-gradient-to-l from-orange-500 via-orange-400 to-transparent rounded-full opacity-80 animate-pulse"></div>
          <div className="w-12 h-2 bg-gradient-to-l from-yellow-400 via-orange-300 to-transparent rounded-full opacity-70 animate-pulse" style={{ animationDelay: '0.2s' }}></div>
        </div>
        
        {/* Astronaut Mascot with Hot Dog */}
        <img 
          src="https://customer-assets.emergentagent.com/job_wiener-wagon/artifacts/8d152tg4_grok_image_xu381va-1.png" 
          alt="Flying Sauce Dogz Astronaut" 
          className="w-20 h-20 object-contain drop-shadow-2xl"
        />
        
        {/* Glow effect around astronaut */}
        <div className="absolute inset-0 w-20 h-20 bg-orange-500 rounded-full blur-xl opacity-20 animate-pulse"></div>
        
        {/* Additional sparkles */}
        <div className="absolute -top-2 -right-2 w-2 h-2 bg-cyan-400 rounded-full animate-ping"></div>
        <div className="absolute -bottom-1 -left-1 w-1 h-1 bg-orange-500 rounded-full animate-ping" style={{ animationDelay: '0.5s' }}></div>
      </div>
    </div>
  );
};

export default FloatingRocket;
